import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { ExclusionListSelectorDataProviderFactory } from '../factory/ExclusionListSelectorDataProviderFactory';
import { ExclusionListSelectorWebComponentSchema } from '../types';
import { ExclusionListSelectorGzDataProvider } from '../dataProvider/ExclusionListSelectorGzDataProvider';

export class ExclusionListSelectorRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ExclusionListSelectorDataProviderFactory;
  public dataProvider: ExclusionListSelectorGzDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new ExclusionListSelectorDataProviderFactory(),
    });
  }

  async getExclusionList(companyId, type, extraParams): Promise<ExclusionListSelectorWebComponentSchema | undefined> {
    let response;
    try {
      response = await this.dataProvider.getExclusionList(companyId, type, extraParams);
    } catch (err) {
      console.error(err);
    }

    if (response && response['success']) {
      if (response['data'].length > 0) {
        for (let index = 0; index < response['data'].length; index++) {
          response['data'][index]['label'] = response['data'][index]['name'];
          response['data'][index]['value'] = response['data'][index]['_id'];
          delete response['data'][index]['_id'];
          delete response['data'][index]['name'];
        }
      } else {
        response['data'] = [];
      }
    }
    return response;
  }
}
